import client from "@/utils/api/client";

export const requestJoinTeam = async (teamId: number) => {
  return client.teamsIdRequestJoinPost({ id: teamId });
};
